import { render, staticRenderFns } from "./PromoSentEvent.vue?vue&type=template&id=3e737d89"
import script from "./PromoSentEvent.vue?vue&type=script&lang=js"
export * from "./PromoSentEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports